import { downloadPdfDocumentMutation } from './interfaces';
import { apiService } from '../api';

const eventService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    downloadPdfDocument: builder.mutation<
      downloadPdfDocumentMutation['response'],
      downloadPdfDocumentMutation['request']
    >({
      query: ({ documentRequestId }) => ({
        url: `/document-request/manager/download-document/${documentRequestId}`,
        method: 'POST',
      }),
    }),
  }),
});

export default eventService;
